import { useEffect, useMemo } from 'react'
import style from  '../../../../sass/pages/profile/profile.module.scss'
import { senderCities } from '../../../../data/static-data'
import { useTranslation } from 'react-i18next'

const SenderTownInput = ({state, setState, enabled, senderCityCode }) => {
    const {t} = useTranslation()
    const handleChange = (e) => {
        if(!e.target.value) {
            setState("")
            return
        }
        setState(+e.target.value)
    }

    const city = useMemo(() => {
        let city = senderCities.find(city => {
            return city.value === senderCityCode
        })
        return city
    }, [senderCityCode])

    useEffect(() => {
        if(city) {
            let containsTown = city.towns.find(town => {
                return +town.value === +state
            })

            if(!containsTown)
                setState(city.towns[0].value)
        }
        else
            setState("")
    }, [city, setState, state])

    return (
        <div className="grid grid-cols-8 xs:grid-cols-12 items-center">
            <span className='col-span-4 text-xs text-left font-bold'>
                {t("user.inputs.town.title")}
            </span>
            <select
                className={`${style.select} col-span-4 text-xs text-left font-bold`}
                id="sender-region"
                value={state}
                onInput={handleChange}
                disabled={!enabled}
            >
                <option value="" disabled selected hidden></option>
                {city?.towns?.map((option, index) => (
                    <option
                        selected={+state === +option.value}
                        key={index}
                        value={option.value}
                    >
                        {option.text}
                    </option>
                ))}
            </select>
        </div>
  )
}

export default SenderTownInput